module.exports = __webpack_public_path__ + "/images/enisa-v.48041f8.png";